import React from "react";

const Wheel = () => {
  return (
    <div className="wheel">
      <svg
        width="60vh"
        height="60vh"
        viewBox="0 0 770 770"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Frame 8" clipPath="url(#clip0_43_2)">
          <g id="Wheel">
            <circle
              id="Ellipse 4"
              cx="384.5"
              cy="383.793"
              r="250"
              fill="#20262A"
            />
            <circle
              id="Ellipse 17"
              cx="384.5"
              cy="383.793"
              r="250"
              fill="#20262A"
            />
            <circle
              id="Ellipse 8"
              cx="384.5"
              cy="383.793"
              r="253"
              fill="#20262A"
              stroke="#161D22"
              stroke-width="6"
            />
            <circle
              id="Ellipse 18"
              cx="384.5"
              cy="383.793"
              r="253"
              fill="#20262A"
              stroke="#161D22"
              stroke-width="6"
            />
            <circle
              id="Ellipse 20"
              cx="384.5"
              cy="384.793"
              r="278"
              stroke="#161D22"
              stroke-width="6"
              stroke-dasharray="12 12"
            />
            <circle
              id="Ellipse 5"
              cx="384.5"
              cy="383.793"
              r="218"
              stroke="url(#paint0_linear_43_2)"
              stroke-width="4"
            />
            <circle
              id="Ellipse 19"
              cx="384.5"
              cy="383.793"
              r="218"
              stroke="url(#paint1_linear_43_2)"
              stroke-width="4"
            />
            <circle
              id="Ellipse 9"
              cx="384.5"
              cy="383.793"
              r="218"
              stroke="url(#paint2_linear_43_2)"
              stroke-width="4"
            />
            <circle
              id="Ellipse 6"
              cx="384.5"
              cy="383.793"
              r="159"
              stroke="url(#paint3_linear_43_2)"
              stroke-width="2"
            />
            <circle
              id="Ellipse 10"
              cx="384.5"
              cy="383.793"
              r="159"
              stroke="url(#paint4_linear_43_2)"
              stroke-opacity="0.75"
              stroke-width="2"
            />
            <circle
              id="Ellipse 7"
              cx="384.5"
              cy="384.793"
              r="137"
              stroke="black"
              stroke-width="8"
            />
            <circle
              id="Ellipse 11"
              cx="384.5"
              cy="383.793"
              r="119"
              stroke="#D5A5FB"
              stroke-opacity="0.38"
              stroke-width="2"
            />
            <circle
              id="Ellipse 12"
              cx="384.5"
              cy="383.793"
              r="47.5"
              fill="#28343E"
              stroke="black"
              stroke-width="5"
            />
            <circle
              id="Ellipse 13"
              cx="384"
              cy="384.293"
              r="34"
              fill="#333C3F"
              stroke="#596169"
              stroke-width="5"
            />
            <circle
              id="Ellipse 14"
              cx="384.5"
              cy="383.793"
              r="21"
              fill="#6E44A3"
            />
            <g id="Ellipse 15">
              <mask id="path-16-inside-1_43_2" fill="white">
                <path d="M468.725 406.529C465.854 418.1 460.82 428.97 453.91 438.518C447 448.066 438.349 456.105 428.451 462.176C418.554 468.247 407.604 472.231 396.226 473.9C384.848 475.57 373.265 474.893 362.139 471.907L366.121 455.857C375.22 458.299 384.693 458.853 393.999 457.487C403.304 456.122 412.26 452.864 420.355 447.898C428.449 442.933 435.524 436.359 441.176 428.55C446.828 420.741 450.945 411.851 453.293 402.388L468.725 406.529Z" />
              </mask>
              <path
                d="M468.725 406.529C465.854 418.1 460.82 428.97 453.91 438.518C447 448.066 438.349 456.105 428.451 462.176C418.554 468.247 407.604 472.231 396.226 473.9C384.848 475.57 373.265 474.893 362.139 471.907L366.121 455.857C375.22 458.299 384.693 458.853 393.999 457.487C403.304 456.122 412.26 452.864 420.355 447.898C428.449 442.933 435.524 436.359 441.176 428.55C446.828 420.741 450.945 411.851 453.293 402.388L468.725 406.529Z"
                fill="#40474C"
                stroke="black"
                stroke-opacity="0.69"
                stroke-width="2"
                mask="url(#path-16-inside-1_43_2)"
              />
            </g>
            <g id="Ellipse 16">
              <mask id="path-17-inside-2_43_2" fill="white">
                <path d="M299.276 361.057C302.146 349.485 307.181 338.616 314.091 329.068C321.001 319.52 329.652 311.481 339.549 305.41C349.447 299.339 360.397 295.355 371.775 293.685C383.153 292.016 394.736 292.693 405.862 295.679L401.88 311.729C392.78 309.287 383.307 308.733 374.002 310.098C364.696 311.464 355.741 314.722 347.646 319.687C339.551 324.652 332.476 331.227 326.825 339.036C321.173 346.844 317.056 355.734 314.708 365.198L299.276 361.057Z" />
              </mask>
              <path
                d="M299.276 361.057C302.146 349.485 307.181 338.616 314.091 329.068C321.001 319.52 329.652 311.481 339.549 305.41C349.447 299.339 360.397 295.355 371.775 293.685C383.153 292.016 394.736 292.693 405.862 295.679L401.88 311.729C392.78 309.287 383.307 308.733 374.002 310.098C364.696 311.464 355.741 314.722 347.646 319.687C339.551 324.652 332.476 331.227 326.825 339.036C321.173 346.844 317.056 355.734 314.708 365.198L299.276 361.057Z"
                fill="#192023"
                stroke="#40474C"
                stroke-width="4"
                mask="url(#path-17-inside-2_43_2)"
              />
            </g>
            <g id="item-3">
              <path
                id="Vector"
                d="M703.194 408.163L700.275 387.625L694.049 395.913C688.769 389.3 688.398 379.714 693.716 372.634C698.758 365.923 707.384 363.494 714.934 366.01L713.924 358.902L722.639 357.664C709.963 351.045 693.997 354.377 685.127 366.183C676.234 378.023 677.514 394.338 687.473 404.665L682.654 411.08L703.192 408.161L703.194 408.163ZM730.622 363.725L735.67 357.005L715.132 359.922L718.05 380.46L724.03 372.5C729.083 379.101 729.365 388.503 724.127 395.476C719.169 402.078 710.74 404.535 703.284 402.219L704.251 409.029L695.015 410.341C707.716 417.07 723.778 413.762 732.684 401.906C741.493 390.18 740.321 374.063 730.623 363.723L730.622 363.725Z"
                fill="#40484F"
              />
            </g>
            <g id="item-4" clipPath="url(#clip1_43_2)">
              <path
                id="Vector_2"
                d="M604.241 621.422L620.151 637.332L641.365 616.119L625.455 600.209L636.061 589.603L617.5 571.041L575.073 613.467L593.635 632.029L604.241 621.422ZM601.59 592.254L617.5 576.344L630.758 589.603L625.455 594.906L622.803 592.254L617.5 597.557L620.151 600.209L614.848 605.512L601.59 592.254ZM622.803 602.861L636.061 616.119L630.758 621.422L628.106 618.771L622.803 624.074L625.455 626.726L620.151 632.029L606.893 618.771L622.803 602.861ZM580.377 613.467L596.287 597.557L609.545 610.816L604.241 616.119L601.59 613.467L596.287 618.771L598.938 621.422L593.635 626.726L580.377 613.467Z"
                fill="#40484F"
              />
            </g>
            <g id="item-6" clipPath="url(#clip2_43_2)">
              <g id="&#233;&#161;&#181;&#233;&#157;&#162;-1">
                <g id="File">
                  <g id="documents_fill">
                    <path
                      id="&#229;&#189;&#162;&#231;&#138;&#182;&#231;&#187;&#147;&#229;&#144;&#136;"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M122.747 632.147L134.252 620.642C135.985 618.909 135.985 616.099 134.252 614.366L122.747 602.861L137.39 588.218C139.701 585.907 143.447 585.907 145.757 588.218L149.941 592.402L154.125 588.218C156.435 585.907 160.182 585.907 162.492 588.218L181.319 607.045C183.63 609.355 183.63 613.101 181.319 615.412L156.217 640.514C153.906 642.825 150.16 642.825 147.849 640.514L143.666 636.331L139.482 640.514C137.171 642.825 133.425 642.825 131.114 640.514L122.747 632.147ZM147.849 632.147L152.033 636.331L177.135 611.228L158.309 592.402L154.125 596.585L164.584 607.045C166.895 609.355 166.895 613.101 164.584 615.412L147.849 632.147ZM118.654 627.872C118.034 626.92 117.697 625.8 117.697 624.646L117.697 610.362C117.697 609.208 118.034 608.088 118.654 607.135L129.023 617.504L118.654 627.872Z"
                      fill="#40484F"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="item-2" clipPath="url(#clip3_43_2)">
              <g id="Group">
                <g id="Group_2">
                  <path
                    id="Vector_3"
                    d="M625.682 126.725L628.375 124.032C628.759 124.791 628.741 125.526 628.391 125.876C627.963 126.304 627.963 126.998 628.391 127.426C628.819 127.854 629.513 127.854 629.941 127.426C631.177 126.19 631.143 124.142 629.973 122.434L630.096 122.311C630.524 121.883 630.525 121.189 630.096 120.761C629.668 120.332 628.974 120.332 628.546 120.761L628.423 120.884C626.715 119.714 624.667 119.68 623.431 120.915C621.704 122.642 622.358 124.747 623.041 126.266L620.348 128.959C619.964 128.201 619.982 127.465 620.331 127.116C620.759 126.688 620.759 125.994 620.331 125.566C619.903 125.138 619.209 125.138 618.781 125.566C617.545 126.802 617.579 128.849 618.749 130.558L618.626 130.681C618.198 131.109 618.198 131.803 618.626 132.231C619.054 132.659 619.748 132.659 620.176 132.231L620.299 132.108C622.008 133.277 624.056 133.312 625.291 132.076C627.018 130.349 626.365 128.244 625.682 126.725ZM624.732 124.575C624.338 123.424 624.511 122.936 624.981 122.466C625.331 122.116 626.066 122.098 626.825 122.482L624.732 124.575ZM621.898 130.509L623.991 128.416C624.385 129.568 624.211 130.056 623.741 130.526C623.392 130.875 622.656 130.893 621.898 130.509Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_3">
                <g id="Group_4">
                  <path
                    id="Vector_4"
                    d="M640.844 134.814L634.23 128.201C633.802 127.773 633.108 127.773 632.68 128.201C632.252 128.629 632.252 129.323 632.68 129.751L639.293 136.364C639.721 136.792 640.415 136.792 640.844 136.364C641.272 135.936 641.272 135.242 640.844 134.814Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_5">
                <g id="Group_6">
                  <path
                    id="Vector_5"
                    d="M628.443 135.641L627.616 134.814C627.188 134.386 626.494 134.386 626.066 134.814C625.638 135.242 625.638 135.936 626.066 136.364L626.893 137.191C627.321 137.619 628.015 137.619 628.443 137.191C628.871 136.763 628.871 136.069 628.443 135.641Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_7">
                <g id="Group_8">
                  <path
                    id="Vector_6"
                    d="M636.71 155.481L613.563 132.334C613.135 131.906 612.441 131.906 612.013 132.334C611.585 132.762 611.585 133.456 612.013 133.884L635.16 157.031C635.588 157.459 636.282 157.459 636.71 157.031C637.138 156.603 637.138 155.909 636.71 155.481Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_9">
                <g id="Group_10">
                  <path
                    id="Vector_7"
                    d="M616.043 144.734L613.563 142.254C613.135 141.826 612.441 141.826 612.013 142.254C611.584 142.682 611.584 143.376 612.013 143.804L614.493 146.284C614.921 146.712 615.615 146.712 616.043 146.284C616.471 145.856 616.471 145.162 616.043 144.734Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_11">
                <g id="Group_12">
                  <path
                    id="Vector_8"
                    d="M610.256 138.947L608.603 137.294C608.175 136.866 607.481 136.866 607.053 137.294C606.625 137.722 606.625 138.416 607.053 138.844L608.706 140.497C609.134 140.925 609.828 140.926 610.256 140.497C610.684 140.069 610.684 139.375 610.256 138.947Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_13">
                <g id="Group_14">
                  <path
                    id="Vector_9"
                    d="M612.736 148.041L610.256 145.561C609.828 145.133 609.134 145.133 608.706 145.561C608.278 145.989 608.278 146.683 608.706 147.111L611.186 149.591C611.614 150.019 612.308 150.019 612.736 149.591C613.164 149.163 613.164 148.469 612.736 148.041Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_15">
                <g id="Group_16">
                  <path
                    id="Vector_10"
                    d="M606.949 142.254L605.296 140.601C604.868 140.173 604.174 140.173 603.746 140.601C603.318 141.029 603.318 141.723 603.746 142.151L605.399 143.804C605.827 144.232 606.521 144.232 606.949 143.804C607.377 143.376 607.377 142.682 606.949 142.254Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_17">
                <g id="Group_18">
                  <path
                    id="Vector_11"
                    d="M609.429 151.348L606.949 148.868C606.521 148.44 605.827 148.439 605.399 148.868C604.971 149.296 604.971 149.99 605.399 150.418L607.879 152.898C608.307 153.326 609.001 153.326 609.429 152.898C609.858 152.47 609.858 151.776 609.429 151.348Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_19">
                <g id="Group_20">
                  <path
                    id="Vector_12"
                    d="M603.643 145.561L601.989 143.908C601.561 143.48 600.867 143.479 600.439 143.908C600.011 144.336 600.011 145.03 600.439 145.458L602.093 147.111C602.521 147.539 603.215 147.539 603.643 147.111C604.071 146.683 604.071 145.989 603.643 145.561Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_21">
                <g id="Group_22">
                  <path
                    id="Vector_13"
                    d="M606.123 154.654L603.643 152.174C603.215 151.746 602.521 151.746 602.093 152.174C601.665 152.602 601.665 153.296 602.093 153.724L604.573 156.204C605.001 156.632 605.695 156.632 606.123 156.204C606.551 155.776 606.551 155.082 606.123 154.654Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_23">
                <g id="Group_24">
                  <path
                    id="Vector_14"
                    d="M600.336 148.868L598.683 147.214C598.255 146.786 597.561 146.786 597.133 147.214C596.705 147.642 596.705 148.336 597.133 148.764L598.786 150.418C599.214 150.846 599.908 150.846 600.336 150.418C600.764 149.99 600.764 149.296 600.336 148.868Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_25">
                <g id="Group_26">
                  <path
                    id="Vector_15"
                    d="M602.816 157.961L600.336 155.481C599.908 155.053 599.214 155.053 598.786 155.481C598.358 155.909 598.358 156.603 598.786 157.031L601.266 159.511C601.694 159.939 602.388 159.939 602.816 159.511C603.244 159.083 603.244 158.389 602.816 157.961Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_27">
                <g id="Group_28">
                  <path
                    id="Vector_16"
                    d="M597.029 152.174L595.376 150.521C594.948 150.093 594.254 150.093 593.826 150.521C593.398 150.949 593.398 151.643 593.826 152.071L595.479 153.724C595.907 154.152 596.601 154.152 597.029 153.724C597.458 153.296 597.457 152.602 597.029 152.174Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_29">
                <g id="Group_30">
                  <path
                    id="Vector_17"
                    d="M636.71 143.908L635.883 143.081C635.455 142.653 634.761 142.653 634.333 143.081C633.905 143.509 633.905 144.203 634.333 144.631L635.16 145.458C635.588 145.886 636.282 145.886 636.71 145.458C637.138 145.03 637.138 144.336 636.71 143.908Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_31">
                <g id="Group_32">
                  <path
                    id="Vector_18"
                    d="M640.843 148.041L640.017 147.214C639.589 146.786 638.895 146.786 638.467 147.214C638.039 147.642 638.039 148.336 638.467 148.764L639.293 149.591C639.721 150.019 640.415 150.019 640.843 149.591C641.271 149.163 641.271 148.469 640.843 148.041Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_33">
                <g id="Group_34">
                  <path
                    id="Vector_19"
                    d="M632.576 139.774L631.75 138.948C631.322 138.52 630.628 138.52 630.2 138.948C629.771 139.376 629.771 140.07 630.2 140.498L631.026 141.324C631.454 141.752 632.148 141.752 632.576 141.324C633.004 140.896 633.004 140.202 632.576 139.774Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_35">
                <g id="Group_36">
                  <path
                    id="Vector_20"
                    d="M639.19 139.774L630.923 131.507C630.495 131.079 629.801 131.079 629.373 131.507C628.945 131.935 628.945 132.629 629.373 133.057L637.64 141.324C638.068 141.752 638.762 141.752 639.19 141.324C639.618 140.896 639.618 140.202 639.19 139.774Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_37">
                <g id="Group_38">
                  <path
                    id="Vector_21"
                    d="M641.67 167.055L638.312 163.696L650.763 151.245C650.969 151.039 651.085 150.76 651.084 150.47L651.084 133.936C651.085 133.645 650.969 133.366 650.763 133.161L629.27 111.667C627.931 110.328 625.752 110.328 624.413 111.667L584.732 151.348C583.393 152.687 583.393 154.865 584.732 156.204L597.184 168.656L595.479 170.361C593.684 172.156 593.684 175.077 595.479 176.871L613.666 195.058C615.461 196.853 618.381 196.853 620.176 195.058L641.67 173.565C643.465 171.77 643.465 168.849 641.67 167.055ZM648.893 136.582L648.893 147.824L644.977 143.908C644.037 142.968 644.037 141.438 644.977 140.498L648.893 136.582ZM616.973 148.868L598.734 167.106L586.282 154.654C585.798 154.17 585.798 153.382 586.282 152.898L625.963 113.217C626.447 112.733 627.235 112.733 627.72 113.217L648.438 133.936L643.427 138.948C641.632 140.742 641.632 143.663 643.427 145.458L648.438 150.469L636.762 162.146L623.483 148.868C621.688 147.073 618.768 147.073 616.973 148.868ZM618.626 193.509C617.686 194.449 616.156 194.449 615.216 193.509L597.029 175.322C596.089 174.381 596.089 172.852 597.029 171.911L618.523 150.418C619.463 149.477 620.993 149.477 621.933 150.418L640.12 168.605C641.06 169.545 641.06 171.075 640.12 172.015L618.626 193.509Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_39">
                <g id="Group_40">
                  <path
                    id="Vector_22"
                    d="M636.71 168.708L621.83 153.828C620.947 152.944 619.51 152.944 618.626 153.828L615.32 157.134C614.436 158.018 614.436 159.455 615.32 160.338L630.2 175.218C631.083 176.101 632.52 176.101 633.403 175.218L636.71 171.911C637.593 171.028 637.593 169.591 636.71 168.708ZM631.853 173.668C631.825 173.697 631.779 173.697 631.75 173.668L616.87 158.788C616.841 158.759 616.841 158.713 616.87 158.684L620.176 155.378C620.205 155.349 620.251 155.349 620.28 155.378L635.16 170.258C635.188 170.286 635.188 170.333 635.16 170.361L631.853 173.668L631.853 173.668Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_41">
                <g id="Group_42">
                  <path
                    id="Vector_23"
                    d="M614.39 164.574L612.736 162.921C611.853 162.038 610.416 162.038 609.533 162.921L607.88 164.574C606.997 165.458 606.997 166.895 607.88 167.778L609.533 169.431C610.416 170.314 611.853 170.314 612.736 169.431L614.39 167.778C615.273 166.895 615.273 165.458 614.39 164.574ZM611.186 167.881C611.158 167.91 611.112 167.91 611.083 167.881L609.43 166.228C609.401 166.199 609.401 166.153 609.43 166.125L611.083 164.471C611.112 164.443 611.158 164.443 611.186 164.471L612.84 166.125C612.868 166.153 612.868 166.199 612.84 166.228L611.186 167.881L611.186 167.881Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_43">
                <g id="Group_44">
                  <path
                    id="Vector_24"
                    d="M627.616 177.801L625.963 176.148C625.08 175.265 623.643 175.265 622.76 176.148L621.106 177.801C620.223 178.685 620.223 180.122 621.106 181.005L622.76 182.658C623.643 183.541 625.08 183.541 625.963 182.658L627.616 181.005C628.5 180.122 628.5 178.685 627.616 177.801ZM624.413 181.108C624.384 181.137 624.338 181.137 624.31 181.108L622.656 179.455C622.628 179.426 622.628 179.38 622.656 179.352L624.31 177.698C624.338 177.67 624.384 177.67 624.413 177.698L626.066 179.352C626.095 179.38 626.095 179.426 626.066 179.455L624.413 181.108Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_45">
                <g id="Group_46">
                  <path
                    id="Vector_25"
                    d="M621.003 171.188L619.35 169.535C618.467 168.651 617.03 168.651 616.146 169.535L614.493 171.188C613.61 172.071 613.61 173.508 614.493 174.391L616.146 176.045C617.03 176.928 618.467 176.928 619.35 176.045L621.003 174.391C621.886 173.508 621.886 172.071 621.003 171.188ZM617.8 174.495C617.771 174.523 617.725 174.523 617.696 174.495L616.043 172.841C616.014 172.813 616.014 172.767 616.043 172.738L617.696 171.085C617.725 171.056 617.771 171.056 617.8 171.085L619.453 172.738C619.481 172.767 619.481 172.813 619.453 172.841L617.8 174.495Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_47">
                <g id="Group_48">
                  <path
                    id="Vector_26"
                    d="M607.776 171.188L606.123 169.535C605.239 168.651 603.803 168.651 602.919 169.535L601.266 171.188C600.383 172.071 600.383 173.508 601.266 174.391L602.919 176.045C603.803 176.928 605.239 176.928 606.123 176.045L607.776 174.391C608.659 173.508 608.659 172.071 607.776 171.188ZM604.573 174.495C604.544 174.523 604.498 174.523 604.469 174.495L602.816 172.841C602.788 172.813 602.788 172.767 602.816 172.738L604.469 171.085C604.498 171.056 604.544 171.056 604.573 171.085L606.226 172.738C606.254 172.767 606.254 172.813 606.226 172.841L604.573 174.495L604.573 174.495Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_49">
                <g id="Group_50">
                  <path
                    id="Vector_27"
                    d="M621.003 184.415L619.35 182.762C618.467 181.878 617.03 181.878 616.146 182.762L614.493 184.415C613.61 185.298 613.61 186.735 614.493 187.618L616.146 189.272C617.03 190.155 618.467 190.155 619.35 189.272L621.003 187.618C621.886 186.735 621.886 185.298 621.003 184.415ZM617.8 187.722C617.771 187.75 617.725 187.75 617.697 187.722L616.043 186.068C616.015 186.04 616.015 185.994 616.043 185.965L617.697 184.312C617.725 184.283 617.771 184.283 617.8 184.312L619.453 185.965C619.482 185.994 619.482 186.04 619.453 186.068L617.8 187.722Z"
                    fill="#40484F"
                  />
                </g>
              </g>
              <g id="Group_51">
                <g id="Group_52">
                  <path
                    id="Vector_28"
                    d="M614.39 177.802L612.736 176.148C611.853 175.265 610.416 175.265 609.533 176.148L607.88 177.802C606.997 178.685 606.997 180.122 607.88 181.005L609.533 182.658C610.416 183.542 611.853 183.542 612.736 182.658L614.39 181.005C615.273 180.122 615.273 178.685 614.39 177.802ZM611.186 181.108C611.158 181.137 611.112 181.137 611.083 181.108L609.43 179.455C609.401 179.426 609.401 179.38 609.43 179.352L611.083 177.698C611.112 177.67 611.158 177.67 611.186 177.698L612.84 179.352C612.868 179.38 612.868 179.426 612.84 179.455L611.186 181.108Z"
                    fill="#40484F"
                  />
                </g>
              </g>
            </g>
            <g id="item-1">
              <path
                id="Vector_29"
                d="M408.122 41.0548L388.024 30.1774C385.908 29.0189 383.341 29.0146 381.222 30.1661L361.088 40.9771C359.611 41.7767 358.71 43.3152 358.707 45.0798C358.704 46.8123 359.6 48.3859 361.074 49.1904L381.173 60.0677C382.23 60.6469 383.417 60.9376 384.572 60.9396C385.727 60.9415 386.914 60.6547 387.974 60.0789L408.108 49.2681C409.585 48.4684 410.486 46.9299 410.489 45.1653C410.492 43.4008 409.596 41.8593 408.122 41.0548Z"
                fill="#40484F"
              />
              <path
                id="Vector_30"
                opacity="0.4"
                d="M377.863 63.816L359.142 54.4167C357.699 53.7085 356.031 53.7699 354.682 54.6018C353.301 55.4658 352.496 56.9082 352.494 58.5124L352.464 76.1903C352.459 79.2382 354.155 82.0002 356.88 83.3843L375.569 92.7835C376.21 93.1054 376.916 93.267 377.622 93.2681C378.456 93.2695 379.29 93.0463 380.029 92.5984C381.41 91.7665 382.215 90.292 382.217 88.6878L382.246 71.0099C382.284 67.9299 380.588 65.168 377.863 63.816Z"
                fill="#40484F"
              />
              <path
                id="Vector_31"
                opacity="0.4"
                d="M414.487 54.7003C413.109 53.8639 411.441 53.7648 410.028 54.5004L391.308 63.8379C388.578 65.2129 386.873 67.9372 386.868 71.0172L386.839 88.6951C386.836 90.2993 387.636 91.7764 389.014 92.6129C389.752 93.0632 390.585 93.2892 391.419 93.2906C392.125 93.2917 392.831 93.1325 393.474 92.8127L412.194 83.4753C414.923 82.1002 416.628 79.3759 416.633 76.296L416.662 58.6181C416.665 57.0139 415.865 55.5688 414.487 54.7003Z"
                fill="#40484F"
              />
            </g>
            <g id="item-5">
              <path
                id="Vector_32"
                d="M67.6215 389.125L60.2172 396.529L63.1253 399.438L73.4378 389.125L54.8753 370.562L51.9465 373.471L67.6215 389.125Z"
                fill="#40484F"
              />
              <path
                id="Vector_33"
                d="M36.3127 366.437V372.625H34.2502C33.1562 372.625 32.107 373.06 31.3334 373.833C30.5598 374.607 30.1252 375.656 30.1252 376.75V393.25C30.1252 394.344 30.5598 395.393 31.3334 396.167C32.107 396.94 33.1562 397.375 34.2502 397.375H36.3127V403.562C36.3127 404.657 36.7473 405.706 37.5209 406.479C38.2945 407.253 39.3437 407.688 40.4377 407.688H83.7503C84.8443 407.688 85.8935 407.253 86.6671 406.479C87.4407 405.706 87.8753 404.657 87.8753 403.562V366.437C87.8753 365.343 87.4407 364.294 86.6671 363.521C85.8935 362.747 84.8443 362.312 83.7503 362.312H40.4377C39.3437 362.312 38.2945 362.747 37.5209 363.521C36.7473 364.294 36.3127 365.343 36.3127 366.437ZM34.2502 393.25L34.2502 376.75L42.5002 376.75L42.5002 393.25L34.2502 393.25ZM83.7503 366.437V403.562H40.4377V397.375H46.6252V372.625H40.4377V366.437H83.7503Z"
                fill="#40484F"
              />
            </g>
            <g id="item-2_2" clipPath="url(#clip4_43_2)">
              <g id="_x35_07_x2C__Board_x2C__chip_x2C__circuit_x2C__network_x2C__electronic">
                <g id="Group_53">
                  <path
                    id="Vector_34"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M165.127 166.817L165.096 166.817L165.065 166.817C164.86 166.822 164.675 166.909 164.542 167.041C164.397 167.18 164.311 167.377 164.309 167.592C164.307 167.807 164.395 168.006 164.533 168.146C164.672 168.287 164.869 168.377 165.084 168.379C165.299 168.381 165.498 168.293 165.639 168.155C165.779 168.016 165.869 167.818 165.871 167.604C165.873 167.389 165.785 167.19 165.647 167.049C165.515 166.916 165.331 166.825 165.127 166.817ZM159.109 169.791C159.247 169.932 159.445 170.022 159.659 170.024C159.874 170.026 160.073 169.938 160.214 169.799C160.358 169.661 160.445 169.467 160.446 169.249C160.448 169.034 160.36 168.835 160.222 168.695C160.086 168.554 159.893 168.467 159.681 168.462L159.671 168.462L159.661 168.462C159.449 168.464 159.258 168.548 159.117 168.686C158.976 168.825 158.886 169.022 158.884 169.237C158.883 169.452 158.97 169.651 159.109 169.791ZM159.653 170.863C159.207 170.86 158.802 170.676 158.511 170.38C158.22 170.085 158.042 169.678 158.045 169.231C158.048 168.784 158.232 168.38 158.528 168.089C158.727 167.892 158.977 167.748 159.257 167.675L159.331 157.651L159.36 153.685C159.361 153.456 159.55 153.27 159.782 153.272C160.014 153.274 160.2 153.463 160.199 153.691L160.171 157.484L162.686 160.032C162.761 160.112 162.808 160.214 162.807 160.33L162.768 165.691C162.766 165.923 162.574 166.109 162.345 166.108C162.113 166.106 161.927 165.917 161.929 165.685L161.967 160.498L160.162 158.67L160.096 167.681C160.375 167.758 160.623 167.906 160.82 168.105C161.111 168.401 161.289 168.808 161.285 169.255C161.282 169.701 161.098 170.106 160.803 170.397C160.507 170.688 160.1 170.866 159.653 170.863ZM150.068 144.592C149.929 144.448 149.732 144.358 149.517 144.356C149.302 144.355 149.103 144.442 148.962 144.581C148.822 144.723 148.731 144.917 148.73 145.132C148.728 145.35 148.816 145.548 148.954 145.689C149.087 145.823 149.27 145.91 149.475 145.921L149.505 145.918L149.536 145.922C149.73 145.916 149.908 145.836 150.042 145.714L150.059 145.697C150.2 145.555 150.29 145.361 150.292 145.143C150.293 144.928 150.206 144.733 150.068 144.592ZM149.523 143.517C149.97 143.52 150.374 143.707 150.665 144.003C150.956 144.295 151.134 144.702 151.131 145.149C151.127 145.599 150.944 146.004 150.648 146.295L150.621 146.318C150.425 146.501 150.185 146.636 149.919 146.709L149.897 149.686C149.896 149.802 149.848 149.904 149.772 149.982L147.395 152.322L151.965 156.96C152.046 157.042 152.087 157.151 152.086 157.257L152.073 159.027C152.071 159.259 151.882 159.445 151.65 159.444C151.422 159.442 151.236 159.253 151.237 159.021L151.249 157.425L144.983 151.069C144.908 150.994 144.861 150.887 144.862 150.772L144.872 149.319C144.874 149.087 145.067 148.901 145.295 148.902C145.527 148.904 145.713 149.093 145.711 149.325L145.702 150.604L146.806 151.724L149.06 149.506L149.08 146.703C148.801 146.626 148.553 146.478 148.357 146.278C148.066 145.983 147.888 145.576 147.891 145.126C147.894 144.679 148.078 144.274 148.373 143.987C148.669 143.695 149.076 143.514 149.523 143.517ZM155.492 142.947C155.35 142.803 155.156 142.712 154.941 142.711C154.733 142.709 154.545 142.79 154.404 142.918L154.387 142.939C154.243 143.078 154.153 143.271 154.151 143.49C154.15 143.704 154.237 143.9 154.379 144.044C154.515 144.181 154.708 144.271 154.92 144.276L154.93 144.276L154.94 144.276C155.152 144.275 155.343 144.187 155.484 144.052C155.625 143.91 155.715 143.716 155.717 143.501C155.718 143.283 155.631 143.088 155.492 142.947ZM154.947 141.872C155.394 141.875 155.799 142.062 156.09 142.358C156.378 142.65 156.559 143.057 156.555 143.507C156.552 143.954 156.365 144.358 156.073 144.646C155.874 144.843 155.624 144.991 155.344 145.064L155.241 159.05C155.239 159.282 155.051 159.468 154.818 159.467C154.587 159.465 154.4 159.276 154.402 159.044L154.43 155.255L151.914 152.702C151.84 152.627 151.793 152.521 151.794 152.405L151.833 147.044C151.835 146.815 152.024 146.625 152.255 146.627C152.487 146.629 152.674 146.821 152.672 147.05L152.634 152.237L154.439 154.068L154.505 145.058C154.226 144.981 153.977 144.829 153.781 144.633C153.49 144.338 153.312 143.93 153.315 143.484C153.319 143.034 153.503 142.629 153.798 142.341L153.825 142.314C154.118 142.036 154.514 141.869 154.947 141.872ZM121.57 155.888L151.624 186.384L153.664 184.373L126.133 156.436C125.971 156.271 125.973 156.005 126.137 155.842L138.749 143.418L136.522 141.157L121.57 155.888ZM127.025 156.146L154.557 184.083L154.563 184.093L157.079 186.642L171.662 172.274L171.741 161.531L165.769 155.471C165.654 155.354 165.563 155.213 165.502 155.06C165.439 154.902 165.409 154.738 165.411 154.581L165.417 153.729C165.416 153.384 165.561 153.075 165.788 152.848C166.022 152.618 166.34 152.48 166.681 152.483C167.025 152.486 167.338 152.628 167.565 152.858C167.792 153.091 167.933 153.403 167.93 153.747L167.928 154.078L173.9 160.142C174.012 160.255 174.103 160.395 174.166 160.549C174.227 160.7 174.26 160.864 174.258 161.028L174.194 169.775L187.576 156.589L163.284 131.94L151.675 131.855L142.938 140.464L142.86 151.21L148.825 157.264C148.944 157.381 149.031 157.521 149.095 157.672L149.102 157.685C149.162 157.836 149.191 158 149.19 158.157L149.184 159.006C149.182 159.35 149.04 159.663 148.809 159.89C148.579 160.117 148.264 160.258 147.92 160.255C147.575 160.252 147.262 160.107 147.036 159.88C146.809 159.647 146.668 159.332 146.671 158.987L146.673 158.656L140.735 152.627C140.62 152.514 140.522 152.38 140.455 152.229C140.381 152.065 140.341 151.888 140.342 151.707L140.406 142.959L139.651 143.704L139.644 143.711L139.637 143.721L127.025 156.146ZM173.271 181.222C173.27 181.454 173.081 181.64 172.849 181.638C172.62 181.637 172.434 181.448 172.436 181.216L172.583 161.189L166.367 154.885C166.285 154.803 166.245 154.693 166.246 154.588L166.252 153.735C166.254 153.507 166.443 153.321 166.675 153.322C166.907 153.324 167.093 153.513 167.091 153.741L167.086 154.42L173.299 160.724C173.377 160.803 173.42 160.906 173.419 161.022L173.271 181.222ZM141.32 132.352C141.322 132.12 141.514 131.934 141.743 131.936C141.974 131.937 142.161 132.126 142.159 132.358L142.018 151.549L148.234 157.853C148.316 157.935 148.356 158.041 148.355 158.15L148.349 159C148.347 159.231 148.158 159.418 147.926 159.416C147.694 159.414 147.508 159.225 147.51 158.994L147.515 158.318L141.323 152.031C141.235 151.956 141.177 151.839 141.178 151.713L141.32 132.352ZM181.394 147.458C181.232 147.293 181.233 147.027 181.398 146.864C181.563 146.702 181.829 146.704 181.992 146.869L191.522 156.54C191.685 156.705 191.683 156.97 191.518 157.133L185.922 162.648C185.756 162.811 185.491 162.809 185.328 162.644C185.165 162.482 185.167 162.213 185.332 162.051L190.63 156.83L181.394 147.458ZM175.498 128.244C175.73 128.245 175.916 128.437 175.914 128.666C175.913 128.898 175.724 129.084 175.492 129.082L150.271 128.898C150.039 128.896 149.853 128.707 149.855 128.475C149.856 128.247 150.045 128.057 150.277 128.059L175.498 128.244ZM160.741 126.601C160.973 126.602 161.16 126.794 161.158 127.023C161.156 127.255 160.967 127.441 160.735 127.439L143.28 127.311C143.052 127.31 142.862 127.121 142.864 126.889C142.866 126.66 143.058 126.471 143.287 126.473L160.741 126.601ZM141.503 126.46C141.731 126.461 141.918 126.654 141.916 126.882C141.914 127.114 141.725 127.3 141.497 127.298L139.314 127.282C139.082 127.281 138.896 127.092 138.898 126.86C138.9 126.631 139.088 126.442 139.32 126.444L141.503 126.46ZM176.505 126.764C176.733 126.765 176.923 126.954 176.921 127.186C176.919 127.418 176.727 127.604 176.498 127.603L168.228 127.542C167.996 127.54 167.81 127.352 167.811 127.12C167.813 126.888 168.002 126.701 168.234 126.703L176.505 126.764ZM169.725 163.42C169.723 163.652 169.535 163.838 169.306 163.836C169.074 163.834 168.888 163.646 168.89 163.414L168.899 162.131L167.792 161.011L165.542 163.232L165.521 166.036C165.8 166.113 166.048 166.261 166.245 166.46C166.536 166.756 166.713 167.163 166.71 167.61C166.707 168.056 166.523 168.461 166.228 168.752C165.932 169.043 165.525 169.221 165.079 169.218C164.632 169.214 164.227 169.031 163.936 168.735C163.645 168.44 163.467 168.033 163.471 167.586C163.474 167.143 163.657 166.738 163.953 166.447C164.152 166.247 164.402 166.103 164.682 166.029L164.704 163.052C164.705 162.936 164.754 162.831 164.829 162.756L167.206 160.414L162.633 155.776C162.555 155.693 162.515 155.587 162.515 155.478L162.525 153.708C162.527 153.48 162.719 153.293 162.947 153.295C163.179 153.297 163.365 153.486 163.364 153.714L163.352 155.31L169.615 161.669C169.693 161.745 169.737 161.851 169.736 161.963L169.725 163.42Z"
                    fill="#40484F"
                  />
                </g>
              </g>
            </g>
            <g
              id="graph-infographic-data-element-2-svgrepo-com 1"
              clipPath="url(#clip5_43_2)"
            >
              <g id="_04-Data">
                <g id="g2715">
                  <path
                    id="path2713"
                    d="M398.252 730.687V715.833C398.252 715.774 398.249 715.715 398.243 715.656C398.24 715.631 398.235 715.606 398.232 715.581C398.227 715.548 398.224 715.516 398.217 715.483C398.211 715.454 398.203 715.426 398.196 715.397C398.189 715.369 398.183 715.341 398.175 715.314C398.166 715.285 398.155 715.258 398.145 715.23C398.136 715.203 398.127 715.175 398.115 715.149C398.105 715.123 398.092 715.098 398.08 715.072C398.067 715.045 398.055 715.017 398.041 714.99C398.027 714.966 398.013 714.943 397.999 714.919C397.983 714.893 397.968 714.866 397.951 714.84C397.933 714.814 397.914 714.789 397.895 714.764C397.879 714.743 397.864 714.721 397.847 714.7C397.809 714.654 397.77 714.611 397.728 714.569L387.229 704.07C389.774 702.067 392.982 700.871 396.465 700.871C404.714 700.871 411.426 707.583 411.426 715.832C411.426 723.478 405.662 729.801 398.252 730.687ZM381.61 717.62H394.677V730.687C387.853 729.871 382.426 724.444 381.61 717.62ZM384.702 706.597L392.15 714.045H381.61C381.944 711.256 383.047 708.7 384.702 706.597ZM396.465 697.297C386.244 697.297 377.929 705.612 377.929 715.832C377.929 726.053 386.244 734.368 396.465 734.368C406.685 734.368 415 726.053 415 715.832C415 705.612 406.685 697.297 396.465 697.297Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2719">
                  <path
                    id="path2717"
                    d="M373.908 727.684H371.496C370.509 727.684 369.709 728.484 369.709 729.471C369.709 730.458 370.509 731.258 371.496 731.258H373.908C374.895 731.258 375.695 730.458 375.695 729.471C375.695 728.484 374.895 727.684 373.908 727.684Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2723">
                  <path
                    id="path2721"
                    d="M365.689 727.684H355.941C354.954 727.684 354.154 728.484 354.154 729.471C354.154 730.458 354.954 731.258 355.941 731.258H365.689C366.676 731.258 367.477 730.458 367.477 729.471C367.477 728.484 366.676 727.684 365.689 727.684Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2727">
                  <path
                    id="path2725"
                    d="M373.908 718.592H366.731C365.744 718.592 364.944 719.392 364.944 720.379C364.944 721.366 365.744 722.166 366.731 722.166H373.908C374.895 722.166 375.695 721.366 375.695 720.379C375.695 719.392 374.895 718.592 373.908 718.592Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2731">
                  <path
                    id="path2729"
                    d="M355.941 722.166H360.924C361.911 722.166 362.711 721.366 362.711 720.379C362.711 719.392 361.911 718.592 360.924 718.592H355.941C354.954 718.592 354.154 719.392 354.154 720.379C354.154 721.366 354.954 722.166 355.941 722.166Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2735">
                  <path
                    id="path2733"
                    d="M373.908 709.499H371.496C370.509 709.499 369.709 710.299 369.709 711.286C369.709 712.273 370.509 713.073 371.496 713.073H373.908C374.895 713.073 375.695 712.273 375.695 711.286C375.695 710.299 374.895 709.499 373.908 709.499Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2739">
                  <path
                    id="path2737"
                    d="M355.941 713.073H365.689C366.676 713.073 367.477 712.273 367.477 711.286C367.477 710.299 366.676 709.499 365.689 709.499H355.941C354.954 709.499 354.154 710.299 354.154 711.286C354.154 712.273 354.954 713.073 355.941 713.073Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2743">
                  <path
                    id="path2741"
                    d="M373.908 700.408H368.875C367.888 700.408 367.088 701.208 367.088 702.195C367.088 703.182 367.888 703.982 368.875 703.982H373.908C374.895 703.982 375.695 703.182 375.695 702.195C375.695 701.208 374.895 700.408 373.908 700.408Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2747">
                  <path
                    id="path2745"
                    d="M355.941 703.982H363.068C364.055 703.982 364.855 703.182 364.855 702.195C364.855 701.208 364.055 700.408 363.068 700.408H355.941C354.954 700.408 354.154 701.208 354.154 702.195C354.154 703.182 354.954 703.982 355.941 703.982Z"
                    fill="#40484F"
                  />
                </g>
                <g id="g2751">
                  <path
                    id="path2749"
                    d="M358.446 685.076C359.007 684.515 359.753 684.206 360.546 684.206H381.757V690.148H360.546C359.753 690.148 359.007 689.839 358.446 689.278C357.884 688.716 357.575 687.97 357.575 687.177C357.575 686.395 357.892 685.629 358.446 685.076ZM409.686 685.076C410.247 685.637 410.556 686.383 410.556 687.177C410.556 687.971 410.247 688.717 409.686 689.278C409.125 689.839 408.378 690.148 407.584 690.148H401.962V684.206H407.584C408.378 684.206 409.125 684.515 409.686 685.076ZM385.331 684.206H398.388V690.148H385.331V684.206ZM355.918 691.805C357.155 693.042 358.798 693.723 360.546 693.723H407.584C409.333 693.723 410.977 693.042 412.214 691.805C413.449 690.569 414.13 688.926 414.13 687.177C414.13 685.428 413.449 683.784 412.214 682.549C410.977 681.312 409.333 680.631 407.584 680.631H360.546C358.798 680.631 357.154 681.312 355.918 682.549C354.682 683.785 354.001 685.429 354.001 687.177C354.001 688.925 354.682 690.569 355.918 691.805Z"
                    fill="#40484F"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Highlight">
            <g id="Rectangle 4" style={{ mixBlendMode: "lighten" }}>
              <rect
                x="348"
                y="-5.25"
                width="73.5"
                height="390"
                fill="#D9D9D9"
                fillOpacity="0.32"
              />
            </g>
            <path
              id="Ellipse 21"
              d="M421.5 384.75C421.5 394.497 417.628 403.844 410.736 410.736C403.844 417.628 394.497 421.5 384.75 421.5C375.004 421.5 365.656 417.628 358.764 410.736C351.872 403.844 348 394.497 348 384.75L384.75 384.75H421.5Z"
              fill="#D9D9D9"
              fillOpacity="0.32"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_43_2"
            x1="255.339"
            y1="211.105"
            x2="488.586"
            y2="555.535"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D6A6FC" />
            <stop offset="0.551883" stopColor="#F4E5FF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_43_2"
            x1="255.339"
            y1="211.105"
            x2="488.586"
            y2="555.535"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D6A6FC" />
            <stop offset="0.551883" stopColor="#F4E5FF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_43_2"
            x1="255.339"
            y1="211.105"
            x2="488.586"
            y2="555.535"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D6A6FC" />
            <stop offset="0.551883" stopColor="#F4E5FF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_43_2"
            x1="384.5"
            y1="223.793"
            x2="384.5"
            y2="543.793"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D6A6FC" />
            <stop offset="0.293757" stopColor="#20262A" />
            <stop offset="0.800736" stopColor="#20262A" />
            <stop offset="1" stopColor="#D0A2F5" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_43_2"
            x1="384.5"
            y1="223.793"
            x2="384.5"
            y2="543.793"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D6A6FC" />
            <stop offset="0.293757" stopColor="#20262A" />
            <stop offset="0.800736" stopColor="#20262A" />
            <stop offset="1" stopColor="#D0A2F5" />
          </linearGradient>
          <clipPath id="clip0_43_2">
            <rect
              width="770"
              height="770"
              fill="white"
              transform="translate(0.000244141)"
            />
          </clipPath>
          <clipPath id="clip1_43_2">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(651.971 605.512) rotate(135)"
            />
          </clipPath>
          <clipPath id="clip2_43_2">
            <rect
              width="71"
              height="71"
              fill="white"
              transform="translate(147.849 665.617) rotate(-135)"
            />
          </clipPath>
          <clipPath id="clip3_43_2">
            <rect
              width="70"
              height="70"
              fill="white"
              transform="translate(621.881 104.279) rotate(45)"
            />
          </clipPath>
          <clipPath id="clip4_43_2">
            <rect
              width="78"
              height="78"
              fill="white"
              transform="translate(156.605 211.759) rotate(-135)"
            />
          </clipPath>
          <clipPath id="clip5_43_2">
            <rect
              width="61"
              height="61"
              fill="white"
              transform="matrix(-1 0 0 -1 415 738)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Wheel;
